import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { DocumentFamily } from '@cas/config/documents';
import { setTechLibProductFamilies } from '@customer/store/slices/filtersSlice';

const useProductFamilyOptions = (): DropdownItemProps<DocumentFamily>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(DocumentFamily)
      .map((value: DocumentFamily) => ({
        key: value,
        value,
        stringValue: value,
        label: t(`DocProductFamily.${value}`),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [t]);
};

export const TechLibraryProductFamiliesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<DocumentFamily>
      filterName="techLibProductFamilies"
      label={label ?? t('ProductFamily')}
      action={setTechLibProductFamilies}
      elementRef={elementRef}
      useItemsHook={useProductFamilyOptions}
    />
  );
};

export default TechLibraryProductFamiliesFilter;
